<template>
  <div>
    <el-dialog
        title="Chọn thời gian"
        :visible.sync="isOpen"
        width="30%"
        :before-close="handleClose"
    >
      <div class="block">
        <el-row type="flex" :gutter="10">
          <el-col :span="12">
            <span>Tháng bắt đầu:</span>
            <div>
              <el-date-picker
                  style="width: 100%; margin-top: 6px"
                  v-model="rangeTime.firstMonth"
                  type="month"
                  placeholder="Chọn tháng bắt đầu"
                  format="MM-yyyy"
                  value-format="yyyy-MM"
                  @change="onFirstMonthChange"
              >
              </el-date-picker>
            </div>
            <div v-if="isValid.firstMonth" class="message_error">*Không để trống trường này!</div>
          </el-col>

          <el-col :span="12">
            <span>Tháng kết thúc:</span>
            <div>
              <el-date-picker
                  style="width: 100%; margin-top: 6px"
                  v-model="rangeTime.lastMonth"
                  type="month"
                  placeholder="Chọn tháng kết thúc"
                  format="MM-yyyy"
                  value-format="yyyy-MM"
                  :picker-options="endMonthOptions"
                  :disabled="!rangeTime.firstMonth"
              >
              </el-date-picker>
            </div>
            <div v-if="isValid.lastMonth" class="message_error">*Không để trống trường này!</div>
          </el-col>
        </el-row>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="danger" @click="handleClose">
          <i class="el-icon-circle-close"/>
          Đóng
        </el-button>
        <el-button icon="el-icon-circle-check" :loading="isLoading.submit" type="success" @click="handleSuccess">
          Xác nhận
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>

import schoolConfigService from "@/services/SchoolService/SchoolConfigService";

export default {
  props: {
    isOpen: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      rangeTime: {
        firstMonth: "",
        lastMonth: ""
      },
      isValid: {
        firstMonth: false,
        lastMonth: false,
      },
      idKidList: [],
      isLoading: {
        submit: false,
      }
    }
  },
  watch: {
    "rangeTime.firstMonth"(newVal) {
      if (newVal) {
        this.isValid.firstMonth = false;
      }
    },

    "rangeTime.lastMonth"(newVal) {
      if (newVal) {
        this.isValid.lastMonth = false;
      }
    }
  },
  computed: {
    endMonthOptions() {
      return {
        disabledDate: (time) => {
          if (!this.rangeTime.firstMonth) return true;

          const firstMonth = new Date(this.rangeTime.firstMonth);
          const firstYear = firstMonth.getFullYear();
          const firstMonthValue = firstMonth.getMonth();

          const currentYear = time.getFullYear();
          const currentMonth = time.getMonth();

          // Điều kiện vô hiệu hóa:
          // 1. Năm khác với năm của firstMonth
          // 2. Tháng trước firstMonth
          return currentYear !== firstYear || currentMonth < firstMonthValue;
        },
      };
    },
  },
  methods: {
    handleClose() {
      this.$emit("closeDialog");
      this.resetData();
    },

    resetData() {
      this.rangeTime.firstMonth = "";
      this.rangeTime.lastMonth = "";
    },

    onFirstMonthChange() {
      // Reset lastMonth nếu không hợp lệ khi thay đổi firstMonth
      if (
          this.rangeTime.lastMonth &&
          new Date(this.rangeTime.lastMonth).getFullYear() !==
          new Date(this.rangeTime.firstMonth).getFullYear()
      ) {
        this.rangeTime.lastMonth = null;
      }
    },

    getIdKidList(ids) {
      this.idKidList = ids;
    },

    handleSuccess() {
      if (this.validation()) {
        const firstMonth = this.rangeTime.firstMonth;
        const lastMonth = this.rangeTime.lastMonth;
        const ids = this.idKidList;
        this.isLoading.submit = true;
        schoolConfigService.getDataPrint(firstMonth, lastMonth, ids)
            .then((res) => {
              const data = res.data;
              const listPreview = []

              data.listResponse.map(item => {
                item.responseOneKids.map(data => {
                  listPreview.push(data);
                })
              })

              this.$store.dispatch("finance2Module/preview_bill_data_new", {data: listPreview, firstMonth: firstMonth, lastMonth: lastMonth});
              this.handleClose();
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              this.isLoading.submit = false;
            })
      }
    },

    validation() {
      const firstMonth = this.rangeTime.firstMonth;
      const lastMonth = this.rangeTime.lastMonth;

      this.isValid.firstMonth = !firstMonth;

      this.isValid.lastMonth = !lastMonth;

      return firstMonth && lastMonth;
    }
  }
}
</script>

<style lang="scss" scoped>
.message_error {
  color: red;
  margin-top: 6px;
}
</style>